export class DirectoryModel {
    path: string;
    name: string;
    filesOrDirectories: DirectoryModel[];

    constructor(path?: string, name?: string, filesOrDirectories?: DirectoryModel[]) {
        this.path = path;
        this.name = name;
        this.filesOrDirectories = filesOrDirectories;
    }
}
